import {Link} from 'react-router-dom';
function FooterCon(){    

    return (
        <>        
            <div className="background0 pt-6indx0">
                <div className="content0">
                    <h1 className='mt-4 hddsktp0'>Your next customer is one <u className='fw800'>hyper-personalized</u> interaction away.</h1>
                    <h1 className='hdmobile1'>Your next customer <br />is one <u className='fw800'>hyper-personalized</u> interaction away.</h1>
                    <div  className="row">
                        <div  className="col-12 col-md-12 text-center mb-4 mt-3">                                            
                            <Link className="main-btn btn-hover text-white bg-blue" to="/seller/register">Create account for free</Link>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )
}

export default FooterCon;
